import React, {useEffect, useState} from 'react'
import cn from 'classnames'
import styles from './depositWallet.module.sass'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Card from '../../../../Card'
import TextInput from '../../../../TextInput'
import Switch from '../../../../Switch'
import TooltipTitle from '../../../../../Tooltip/TooltipTitle'
import Toast from '../../../../Toast'
import { toast } from 'react-toastify'


const AddOnModal = ({className, visible, value, setValue, item, onClose}) => {
  
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const [toggle, setToggle] = useState()
  const [activeIndex, setActiveIndex] = useState(1)

  const configureToggle = () => {
    if(item.entitySubType === 'withdrawal'){
        setToggle([{id: 1, name: 'Wallet Info'}, {id: 3, name: 'Withdrawal Controls'}, {id: 4, name: 'Balance Controls'}, {id: 5, name: 'Tax and Compliance'}])
    }else{
        setToggle([{id: 1, name: 'Wallet Info'}, {id: 2, name: 'Deposit Controls'}, {id: 3, name: 'Withdrawal Controls'}, {id: 4, name: 'Balance Controls'}, {id: 5, name: 'Tax and Compliance'}])
    }
  }

  useEffect(() => {
    configureToggle()
  }, [item])

  // Wallte Info
  const [walletDetails, setWalletDetails] = useState(
    {
        enableWithdrawal: (item?.entitySubType === 'withdrawal' ? true: item?.rules?.enableWithdrawal), isTaxApplicable: item?.rules?.isTaxApplicable, isKycRequired: item?.rules?.isKycRequired, entitySubType: item?.entitySubType,
        walletId: item?.rules?.info?.walletId, walletName: item?.rules?.info?.walletName, walletType: item?.rules?.info?.walletType,
        
        maxDepositPerTransaction : item?.rules?.depositControls?.all?.find(x => x.fact === 'maxDepositPerTransaction')?.value, 
        minDepositPerTransaction : item?.rules?.depositControls?.all?.find(x => x.fact === 'minDepositPerTransaction')?.value,
        dailyDepositLimit: item?.rules?.depositControls?.all?.find(x => x.fact === 'dailyDepositLimit')?.value,
        weeklyDepositLimit: item?.rules?.depositControls?.all?.find(x => x.fact === 'weeklyDepositLimit')?.value,
        monthlyDepositLimit: item?.rules?.depositControls?.all?.find(x => x.fact === 'monthlyDepositLimit')?.value,

        maxWithdrawalPerTransaction: item?.rules?.withdrawalControls?.all?.find(x => x.fact === 'maxWithdrawalPerTransaction')?.value,
        minWithdrawalPerTransaction: item?.rules?.withdrawalControls?.all?.find(x => x.fact === 'minWithdrawalPerTransaction')?.value,
        dailyWithdrawalLimit: item?.rules?.withdrawalControls?.all?.find(x => x.fact === 'dailyWithdrawalLimit')?.value,
        weeklyWithdrawalLimit: item?.rules?.withdrawalControls?.all?.find(x => x.fact === 'weeklyWithdrawalLimit')?.value, 
        monthlyWithdrawalLimit : item?.rules?.withdrawalControls?.all?.find(x => x.fact === 'monthlyWithdrawalLimit')?.value,
        withdrawalLockPeriodInDays: item?.rules?.withdrawalControls?.all?.find(x => x.fact === 'withdrawalLockPeriodInDays')?.value,
        
        maxWalletBalance: item?.rules?.balanceControls?.all?.find(x => x.fact === 'maxWalletBalance')?.value,
        minWalletBalanceForWithdrawal: item?.rules?.balanceControls?.all?.find(x => x.fact === 'minWalletBalanceForWithdrawal')?.value,
        
        taxRate: item?.rules?.tax?.taxRate, 
        applicabilityThreshold: item?.rules?.tax?.applicabilityThreshold, 
        taxFreeAllowancePerTransaction: item?.rules?.tax?.taxFreeAllowancePerTransaction,

        kycApplicabilityThresholdForTransactions : item?.rules?.compliance?.all?.find(x => x.fact === 'kycApplicabilityThresholdForTransactions')?.value,
        kycApplicabilityThresholdForTotalDeposits: item?.rules?.compliance?.all?.find(x => x.fact === 'kycApplicabilityThresholdForTotalDeposits')?.value,
        kycApplicabilityThresholdForTotalWinnings: item?.rules?.compliance?.all?.find(x => x.fact === 'kycApplicabilityThresholdForTotalWinnings')?.value,
    }
  )

  const onChangeWallet = (e, type) => {
    const {name, value} = e.target
    setWalletDetails(walletDetails => ({...walletDetails, [name]: (type === 'integer' ? ((value !== '' && value !== null) ? parseInt(value) : '') : value)}))
  }

  const toggleWithdrawal = (e, id) => {
    setWalletDetails(walletDetails => ({...walletDetails, enableWithdrawal: e?.target?.checked, maxWithdrawalPerTransaction: '', minWithdrawalPerTransaction: '', dailyWithdrawalLimit: '', weeklyWithdrawalLimit: '', monthlyWithdrawalLimit : '', withdrawalLockPeriodInDays: ''})) 
    setValue(wallets => wallets && wallets.map(x => x?.entitySubType === id ? 
        {
            ...x,
            rules: {
                ...x?.rules,
                enableWithdrawal: e?.target?.checked,
                withdrawalControls: (e?.target?.checked ?
                    {
                        all: [
                            {fact: 'maxWithdrawalPerTransaction', operator: 'lessThanInclusive', value: ''},
                            {fact: 'minWithdrawalPerTransaction', operator: 'greaterThanInclusive', value: ''},
                            {fact: 'dailyWithdrawalLimit', operator: 'lessThanInclusive', value: ''},
                            {fact: 'weeklyWithdrawalLimit', operator: 'lessThanInclusive', value: ''},
                            {fact: 'monthlyWithdrawalLimit', operator: 'lessThanInclusive', value: ''},
                            {fact: 'withdrawalLockPeriodInDays', operator: 'greaterThanInclusive', value: ''},
                        ]
                    }
                : null)
            }
        } 
        : x
    ))
  }

  const toggleTax = (e, id) => {
    setWalletDetails(walletDetails => ({...walletDetails, isTaxApplicable: e?.target?.checked, taxRate: '', applicabilityThreshold: '', taxFreeAllowancePerTransaction: ''})) 
    setValue(wallets => wallets && wallets.map(x => x?.entitySubType === id ? 
        {
            ...x,
            rules: {
                ...x?.rules, 
                isTaxApplicable: e?.target?.checked,
                tax: (e?.target?.checked ?
                    {
                        taxRate: null,
                        applicabilityThreshold: null,
                        taxFreeAllowancePerTransaction: null,
                    }
                : null)
            }
        } 
        : x
    ))
  }

  const toggleKYC = (e, id) => {
    setWalletDetails(walletDetails => ({...walletDetails, isKycRequired: e?.target?.checked, kycApplicabilityThresholdForTransactions : '', kycApplicabilityThresholdForTotalDeposits: '', kycApplicabilityThresholdForTotalWinnings: ''})) 
    setValue(wallets => wallets && wallets.map(x => x?.entitySubType === id ? 
        {
            ...x,
            rules: {
                ...x?.rules, 
                isKycRequired: e?.target?.checked,
                compliance: (e?.target?.checked ?
                    {
                        all: [
                            {fact: 'kycApplicabilityThresholdForTransactions', operator: 'lessThanInclusive', value: ''},
                            {fact: 'kycApplicabilityThresholdForTotalDeposits', operator: 'lessThanInclusive', value: ''},
                            {fact: 'kycApplicabilityThresholdForTotalWinnings',  operator: 'lessThanInclusive', value: ''}
                        ]
                    }
                : null)
            }
        } 
        : x
    ))
  }

    const validation = (obj) => {

        const generalKeys = ["walletId", "walletName", "walletType"]
        const balanceKeys = walletDetails?.enableWithdrawal ? ["maxWalletBalance", "minWalletBalanceForWithdrawal"] : ["maxWalletBalance"]
        const depositKeys = ["maxDepositPerTransaction", "minDepositPerTransaction", "dailyDepositLimit", "weeklyDepositLimit", "monthlyDepositLimit"]
        const withdrawalKeys = ["maxWithdrawalPerTransaction", "minWithdrawalPerTransaction", "dailyWithdrawalLimit", "weeklyWithdrawalLimit", "monthlyWithdrawalLimit", "withdrawalLockPeriodInDays"]
        const taxKeys = ['taxRate', 'applicabilityThreshold', 'taxFreeAllowancePerTransaction']
        const kycKeys = walletDetails?.entitySubType === 'deposit' ? ['kycApplicabilityThresholdForTransactions', 'kycApplicabilityThresholdForTotalDeposits'] : ['kycApplicabilityThresholdForTransactions', 'kycApplicabilityThresholdForTotalWinnings']

        const isGeneralValid = generalKeys.every((key) => obj[key] !== null && obj[key] !== "" && obj[key] !== undefined)
        if (!isGeneralValid){
            toast.error(<Toast type='Error' messages='All the fields in wallet info are required.' />, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
            return false;
        }

        if(obj?.entitySubType === 'deposit'){
            const isDepositValid = depositKeys.every((key) => obj[key] !== null && obj[key] !== "" && obj[key] !== undefined)
            if (!isDepositValid){
                toast.error(<Toast type='Error' messages='All the fields in deposit control are required.' />, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
                return false;
            }
        }

        if (obj.enableWithdrawal) {
            const isWithdrawalValid = withdrawalKeys.every((key) => obj[key] !== null && obj[key] !== "" && obj[key] !== undefined)
            
            if (!isWithdrawalValid){
                toast.error(<Toast type='Error' messages='All the fields in withdrawal control are required.' />, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
                return false;
            } 
        }

        const isBalanceValid = balanceKeys.every((key) => obj[key] !== null && obj[key] !== "" && obj[key] !== undefined)
        if (!isBalanceValid){
            toast.error(<Toast type='Error' messages='All the fields in balance control are required.' />, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
            return false;
        }

        if (obj.isKycRequired) {
            const isKYCValid = kycKeys.every((key) => obj[key] !== null && obj[key] !== "" && obj[key] !== undefined)
            
            if (!isKYCValid){
                toast.error(<Toast type='Error' messages='All the fields in tax and compliance are required.' />, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
                return false;
            } 
        }
        
        // Check Tax-related keys if isTaxApplicable is true
        if (obj.isTaxApplicable) {
            const isTaxValid = taxKeys.every((key) => obj[key] !== null && obj[key] !== "" && obj[key] !== undefined)
            if (!isTaxValid){
                toast.error(<Toast type='Error' messages='All the fields in tax and compliance are required.' />, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
                return false;
            }
        }
        return true
    }

    const save = () => {
        if(validation(walletDetails)){
            setValue(wallets => wallets.map(x => x?.entitySubType === walletDetails?.entitySubType ?
                {
                    ...x,
                    rules: {
                        enableWithdrawal : walletDetails?.enableWithdrawal,
                        isKycRequired : walletDetails?.isKycRequired,
                        isTaxApplicable : walletDetails?.isTaxApplicable,
                        info: {walletName: walletDetails?.walletName, walletId: walletDetails?.walletId, walletType: walletDetails?.walletType},
                        ...(walletDetails?.walletType === 'deposit' ?
                            {
                                depositControls: {
                                    all: [
                                        {fact: 'maxDepositPerTransaction', operator: 'lessThanInclusive', value: walletDetails?.maxDepositPerTransaction},
                                        {fact: 'minDepositPerTransaction', operator: 'greaterThanInclusive', value: walletDetails?.minDepositPerTransaction},
                                        {fact: 'dailyDepositLimit', operator: 'lessThanInclusive', value: walletDetails?.dailyDepositLimit},
                                        {fact: 'weeklyDepositLimit', operator: 'lessThanInclusive', value: walletDetails?.weeklyDepositLimit},
                                        {fact: 'monthlyDepositLimit', operator: 'lessThanInclusive', value: walletDetails?.monthlyDepositLimit},
                                    ]
                                }
                            }
                        : {depositControls: null}
                        ), 
                        balanceControls: {
                            all: [
                                {fact: 'maxWalletBalance', operator: 'lessThanInclusive', value: walletDetails?.maxWalletBalance},
                                ...(walletDetails?.enableWithdrawal ?
                                        [{fact: 'minWalletBalanceForWithdrawal', operator: 'greaterThanInclusive', value: walletDetails?.minWalletBalanceForWithdrawal}]
                                    :
                                        []
                                )
                            ]
                        },
                        ...(walletDetails?.enableWithdrawal ?
                            {
                                withdrawalControls: {
                                    all: [
                                        {fact: 'maxWithdrawalPerTransaction', operator: 'lessThanInclusive', value: walletDetails?.maxWithdrawalPerTransaction},
                                        {fact: 'minWithdrawalPerTransaction', operator: 'greaterThanInclusive', value: walletDetails?.minWithdrawalPerTransaction},
                                        {fact: 'dailyWithdrawalLimit', operator: 'lessThanInclusive', value: walletDetails?.dailyWithdrawalLimit},
                                        {fact: 'weeklyWithdrawalLimit', operator: 'lessThanInclusive', value: walletDetails?.weeklyWithdrawalLimit},
                                        {fact: 'monthlyWithdrawalLimit', operator: 'lessThanInclusive', value: walletDetails?.monthlyWithdrawalLimit},
                                        {fact: 'withdrawalLockPeriodInDays', operator: 'greaterThanInclusive', value: walletDetails?.withdrawalLockPeriodInDays},
                                    ]
                                }
                            }
                        : {withdrawalControls: null}),
                        ...(walletDetails?.isTaxApplicable ?
                            {
                                tax: {
                                    taxRate: walletDetails?.taxRate,
                                    applicabilityThreshold: walletDetails?.applicabilityThreshold,
                                    taxFreeAllowancePerTransaction: walletDetails?.taxFreeAllowancePerTransaction,
                                }
                            }
                        : 
                            {tax: null}
                        ),
                        ...(walletDetails?.isKycRequired ? 
                            {
                                compliance : {
                                    all: [
                                        {fact: 'kycApplicabilityThresholdForTransactions', operator: 'lessThanInclusive', value: walletDetails?.kycApplicabilityThresholdForTransactions},
                                        ...(walletDetails?.walletType === 'deposit' ? 
                                            [{fact: 'kycApplicabilityThresholdForTotalDeposits', operator: 'lessThanInclusive', value: walletDetails?.kycApplicabilityThresholdForTotalDeposits}]
                                        : 
                                            []
                                        ),
                                        ...(walletDetails?.walletType === 'withdrawal' ? 
                                            [{fact: 'kycApplicabilityThresholdForTotalWinnings', operator: 'lessThanInclusive', value: walletDetails?.kycApplicabilityThresholdForTotalWinnings}]
                                        : 
                                            []
                                        )
                                    ]
                                }
                            }
                        : 
                            {compliance : null}
                    ),
                    }
                }
                :
                x
            ))
            onClose()
        }
    }

    return (
        <>
        <div className={styles.container}>
            <div className={styles.deposit}>
                <div className={styles.modalHeading}>
                    <div className={styles.block}></div><span>Edit {walletDetails?.walletType?.charAt(0).toUpperCase() + walletDetails?.walletType?.slice(1)} Wallet</span>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.toggle}>
                        {toggle && toggle.map((x, index) => (
                            <button className={cn(styles.link, {[styles.active]: activeIndex === x?.id}, {[styles.grid]: item?.entitySubType === 'withdrawal'}, {[styles.disabled] : (x?.name === 'Withdrawal Controls' && !walletDetails?.enableWithdrawal) ? true : false})} onClick={() => setActiveIndex((x.id))} key={index}>
                                <p>{x?.name}</p>
                            </button>
                        ))}
                    </div>
                    {activeIndex === 1 &&
                        <div className={styles.wrapper}>
                            <div className={styles.group}>
                                <TextInput name='walletName' className={styles.field} label='Wallet Name*' placeholder='Enter Wallet Name' tooltip={TooltipTitle.RMGWalletName} value={walletDetails?.walletName} onChange={(e) => {onChangeWallet(e, 'text')}} />
                                <TextInput name='walletId' className={styles.field} label='Wallet Id*' placeholder='Enter Wallet Id' tooltip={TooltipTitle.RMGWalletID} value={walletDetails?.walletId} onChange={(e) => {onChangeWallet(e, 'text')}} />
                            </div>
                            <div className={styles.group}>
                                {item?.entitySubType === 'deposit' &&
                                    <div className={styles.field}>
                                        <div className={styles.info}>
                                            Enable Withdrawals*
                                        </div>
                                        <div className={styles.switch}>
                                            <Switch size='small' disabled={walletDetails?.entitySubType === 'withdrawal'} value={walletDetails?.enableWithdrawal} onChange={(e) => toggleWithdrawal(e, walletDetails?.entitySubType)}/>
                                        </div>
                                    </div>
                                }
                                <TextInput disabled className={styles.field} label='Wallet Type*' placeholder='Enter Wallet Type' tooltip={TooltipTitle.RMGWalletType} value={walletDetails?.walletType?.charAt(0).toUpperCase() + walletDetails?.walletType?.slice(1)} />
                            </div>
                        </div>
                    }
                    {activeIndex === 2 &&
                        <div className={styles.wrapper}>
                            <div className={styles.group}>
                                <TextInput className={styles.field} label='Max Deposit Per Transaction*' placeholder='Enter Max Deposit Per Transaction' tooltip={TooltipTitle.RMGMaxDeposit} name='maxDepositPerTransaction' value={walletDetails?.maxDepositPerTransaction} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                                <TextInput className={styles.field} label='Min Deposit Per Transaction*' placeholder='Enter Min Deposit Per Transaction' tooltip={TooltipTitle.RMGMinDeposit} name='minDepositPerTransaction' value={walletDetails?.minDepositPerTransaction} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                            </div>
                            <div className={styles.group}>
                                <TextInput className={styles.field} label='Daily Deposit Limit*' placeholder='Enter Daily Deposit Limit' tooltip={TooltipTitle.RMGDailyDepositLimit} name='dailyDepositLimit' value={walletDetails?.dailyDepositLimit} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                                <TextInput className={styles.field} label='Weekly Deposit Limit*' placeholder='Enter Weekly Deposit Limit' tooltip={TooltipTitle.RMGWeeklyDepositLimit} name='weeklyDepositLimit' value={walletDetails?.weeklyDepositLimit} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                            </div>
                            <div className={styles.group}>
                                <TextInput className={styles.field} label='Monthly Deposit Limit*' placeholder='Enter Monthly Deposit Limit' tooltip={TooltipTitle.RMGMonthlyDepositLimit} name='monthlyDepositLimit' value={walletDetails?.monthlyDepositLimit} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                            </div>
                        </div>
                    }
                    {activeIndex === 3 &&
                        <div className={styles.wrapper}>
                            <div className={styles.group}>
                                <TextInput className={styles.field} label='Max Withdrawal Per Transaction*' placeholder='Enter Max Withdrawal Per Transaction' tooltip={TooltipTitle.RMGMaxWithdrawl} name='maxWithdrawalPerTransaction' value={walletDetails?.maxWithdrawalPerTransaction} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                                <TextInput className={styles.field} label='Min Withdrawal Per Transaction*' placeholder='Enter Min Withdrawal Per Transaction' tooltip={TooltipTitle.RMGMinWithdrawl} name='minWithdrawalPerTransaction' value={walletDetails?.minWithdrawalPerTransaction} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                            </div>
                            <div className={styles.group}>
                                <TextInput className={styles.field} label='Daily Withdrawal Limit*' placeholder='Enter Daily Withdrawal Limit' tooltip={TooltipTitle.RMGDailyWithdrawalLimit} name='dailyWithdrawalLimit' value={walletDetails?.dailyWithdrawalLimit} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                                <TextInput className={styles.field} label='Weekly Withdrawal Limit*' placeholder='Enter Weekly Withdrawal Limit 'tooltip={TooltipTitle.RMGWeeklyWithdrawalLimit} name='weeklyWithdrawalLimit' value={walletDetails?.weeklyWithdrawalLimit} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                            </div>
                            <div className={styles.group}>
                                <TextInput className={styles.field} label='Monthly Withdrawal Limit*' placeholder='Monthly Withdrawal Limit' tooltip={TooltipTitle.RMGMonthlyWithdrawalLimit} name='monthlyWithdrawalLimit' value={walletDetails?.monthlyWithdrawalLimit} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                                <TextInput className={styles.field} label='Withdrawal Lock Period (days)*' placeholder='Withdrawal Lock Period (days)' tooltip={TooltipTitle.RMGWithdrawalLockPeriod} name='withdrawalLockPeriodInDays' value={walletDetails?.withdrawalLockPeriodInDays} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                            </div>
                        </div>
                    }
                    {activeIndex === 4 &&
                        <div className={styles.wrapper}>
                            <div className={styles.group}>
                                <TextInput className={styles.field} label='Max Wallet Balance*' placeholder='Enter Max Wallet Balance' tooltip={TooltipTitle.RMGMaxBalance} name='maxWalletBalance'  value={walletDetails?.maxWalletBalance} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                                <TextInput disabled={!walletDetails?.enableWithdrawal} className={styles.field} label='Min Wallet Balance for Withdrawals*' placeholder='Enter Min Wallet Balance for Withdrawals' tooltip={TooltipTitle.RMGMinBalance} name='minWalletBalanceForWithdrawal' value={walletDetails?.minWalletBalanceForWithdrawal} onChange={(e) => {onChangeWallet(e, 'integer')}}/>
                            </div>
                        </div>
                    }
                    {activeIndex === 5 &&
                        <div className={styles.wrapper}>
                            <div className={styles.group}>
                                <div className={styles.field}>
                                    <div className={styles.info}>
                                        Apply Tax Deduction*
                                    </div>
                                    <div className={styles.switch}>
                                        <Switch size='small' value={walletDetails?.isTaxApplicable} onChange={(e) => toggleTax(e, walletDetails?.entitySubType)}/>
                                    </div>
                                </div>
                                <div className={styles.field}>
                                    <div className={styles.info}>
                                        KYC Required*
                                    </div>
                                    <div className={styles.switch}>
                                        <Switch size='small' value={walletDetails?.isKycRequired} onChange={(e) => toggleKYC(e, walletDetails?.entitySubType)}/>
                                    </div>
                                </div>
                                
                            </div>

                            <div className={styles.group}>
                                {walletDetails.isTaxApplicable && <TextInput className={styles.field} label='Tax Rate (%)*' placeholder='Enter Tax Rate (%)' tooltip={TooltipTitle.RMGTaxRate} name='taxRate' value={walletDetails?.taxRate} onChange={(e) => {onChangeWallet(e, 'integer')}}/> }
                                {walletDetails.isKycRequired && <TextInput className={styles.field} label='KYC Applicability Threshold for Transactions*' placeholder='KYC Applicability Threshold for Transactions' tooltip={TooltipTitle.RMGKYCThresholdForTransaction} name='kycApplicabilityThresholdForTransactions' value={walletDetails?.kycApplicabilityThresholdForTransactions} onChange={(e) => {onChangeWallet(e, 'integer')}}/>}
                            </div>

                            <div className={styles.group}>
                                {walletDetails.isTaxApplicable &&  <TextInput className={styles.field} label='Tax Applicability Threshold*' placeholder='Enter Tax Applicability Threshold' tooltip={TooltipTitle.RMGTaxThreshold} name='applicabilityThreshold' value={walletDetails?.applicabilityThreshold} onChange={(e) => {onChangeWallet(e, 'integer')}}/>}
                                {(walletDetails.isKycRequired && walletDetails.walletType === 'deposit') && <TextInput className={styles.field} label='KYC Applicability Threshold for Total Deposits*' placeholder='Enter KYC Applicability Threshold for Total Deposits' tooltip={TooltipTitle.RMGKYCThresholdForDeposit} name='kycApplicabilityThresholdForTotalDeposits' value={walletDetails?.kycApplicabilityThresholdForTotalDeposits} onChange={(e) => {onChangeWallet(e, 'integer')}}/>}
                                {(walletDetails.isKycRequired && walletDetails.walletType === 'withdrawal') && <TextInput className={styles.field} label='KYC Applicability Threshold for Total Winnings*' placeholder='Enter KYC Applicability Threshold for Total Winnings' tooltip={TooltipTitle.RMGKYCThresholdForDeposit} name='kycApplicabilityThresholdForTotalWinnings' value={walletDetails?.kycApplicabilityThresholdForTotalWinnings} onChange={(e) => {onChangeWallet(e, 'integer')}}/>}
                            </div>

                            <div className={styles.group}>
                                {walletDetails.isTaxApplicable && <TextInput className={styles.field} label='Tax-Free Allowance Per Transaction*' placeholder='Enter Tax-Free Allowance Per Transaction' tooltip={TooltipTitle.RMGTaxFreeAllowance} name='taxFreeAllowancePerTransaction' value={walletDetails?.taxFreeAllowancePerTransaction} onChange={(e) => {onChangeWallet(e, 'integer')}}/>}
                            </div>

                        </div>
                    }
                </div>
                <div className={styles.modalFooter}>
                    <button className={cn(styles.button, 'button-save-small')} onClick={save}>Save</button>
                    <button className={cn(styles.button, 'button-cancel-small')} onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
        </>
    )
}

export default AddOnModal